module.exports = __webpack_public_path__ + "media/images/pages/home_featured/who-we-are-mid-1-c73cfe28298a3b5a8d472a8af2c32b40.png";